export default "__VITE_ASSET__DXAPRYNz__"